import { produce } from "immer";
import { IPayloadAction } from "../../../shared/shared.interfaces";
import { AuthenticationActions } from "../../authentication/authentication.store";
import { IProductRecommendations } from "./product-recommender.model";

export const ProductRecommendationsActions = {
  types: {
    GET_PRODUCT_RECOMMENDATIONS_SUCCESS: "GET_PRODUCT_RECOMMENDATIONS_SUCCESS",
  },
  creators: {
    getProductRecommendationsSuccess: (productRecommendations: IProductRecommendations) => ({
      type: ProductRecommendationsActions.types.GET_PRODUCT_RECOMMENDATIONS_SUCCESS,
      payload: {
        productRecommendations,
      },
    }),
  },
};
export interface IProductRecommendationsReducerInterface {
  productRecommendations: IProductRecommendations;
}

const initialState: IProductRecommendationsReducerInterface = {
  productRecommendations: {} as IProductRecommendations,
};

export const productRecommendationsReducer = produce(
  (draft: IProductRecommendationsReducerInterface, action: IPayloadAction<any>) => {
    switch (action.type) {
      case ProductRecommendationsActions.types.GET_PRODUCT_RECOMMENDATIONS_SUCCESS:
        draft.productRecommendations = action.payload.productRecommendations;
        return;
      case AuthenticationActions.types.LOGOUT:
        return initialState;
      default:
        return draft;
    }
  },
  initialState,
);
